<!-- eslint-disable vue/no-mutating-props -->
<template>

 


<div class="nk-block-head">
  <div class="nk-block-head-content">
    <h5 class="nk-block-title" v-if="formIslem === 'ekle'">Yeni Kullanıcı  Ekle</h5>
    <h5 class="nk-block-title" v-if="formIslem === 'duzenle'">Kullanıcı  Düzenleme</h5>
    <div class="nk-block-des"><p>Kullanıcılar</p></div>
  </div>
</div>

  <form @submit.prevent="gonder">

    <div class="row">
   
    
        <div class="row align-items-center mt-2"  :class="{ 'text-danger': formHatalar.ad }">
        <div class="col-lg-3">
          <label for="ad" class="form-label">Ad</label> 
        </div>
        <div class="col-lg-9">
        <input class="form-control"  id="ad" v-model="localFormData.ad" >
        <span v-if="formHatalar.ad" class="error">{{ formHatalar.ad }}</span>
        </div>
      </div>
    
        <div class="row align-items-center mt-2"  :class="{ 'text-danger': formHatalar.soyad }">
        <div class="col-lg-3">
          <label for="soyad" class="form-label">Soyad</label> 
        </div>
        <div class="col-lg-9">
        <input class="form-control"  id="soyad" v-model="localFormData.soyad" >
        <span v-if="formHatalar.soyad" class="error">{{ formHatalar.soyad }}</span>
        </div>
      </div>
    
        <div class="row align-items-center mt-2"  :class="{ 'text-danger': formHatalar.kullaniciadi }">
        <div class="col-lg-3">
          <label for="kullaniciadi" class="form-label">Kullanıcı Adı</label> 
        </div>
        <div class="col-lg-9">
        <input class="form-control"  id="kullaniciadi" v-model="localFormData.kullaniciadi" >
        <span v-if="formHatalar.kullaniciadi" class="error">{{ formHatalar.kullaniciadi }}</span>
        </div>
      </div>

      <div class="row align-items-center mt-2"  :class="{ 'text-danger': formHatalar.sifre }">
        <div class="col-lg-3">
          <label for="sifre" class="form-label">Yeni Şifre</label> 
        </div>
        <div class="col-lg-9">
        <input class="form-control"  type="password" id="sifre" v-model="localFormData.sifre" >
        <span v-if="formHatalar.sifre" class="error">{{ formHatalar.sifre }}</span>
        </div>
      </div>
      <div class="row align-items-center mt-2"  :class="{ 'text-danger': formHatalar.sifre2 }">
        <div class="col-lg-3">
          <label for="sifre2" class="form-label">Yeni Şifre Tekrarı</label> 
        </div>
        <div class="col-lg-9">
        <input class="form-control"  type="password" id="sifre" v-model="localFormData.sifre2" >
        <span v-if="formHatalar.sifre2" class="error">{{ formHatalar.sifre2 }}</span>
        </div>
      </div>
    
        <div class="row align-items-center mt-2"  :class="{ 'text-danger': formHatalar.telefon }">
        <div class="col-lg-3">
          <label for="telefon" class="form-label">Telefon</label> 
        </div>
        <div class="col-lg-9">
        <input class="form-control"  id="telefon" v-model="localFormData.telefon" >
        <span v-if="formHatalar.telefon" class="error">{{ formHatalar.telefon }}</span>
        </div>
      </div>
    
    
    
    

      <div class="row align-items-center mt-2"  :class="{ 'text-danger': formHatalar.rol }">
        <div class="col-lg-3">
          <label for="rol" class="form-label">Rol</label> 
        </div>
        <div class="col-lg-9">
          <v-select
          v-model="localFormData.rol"
          :options="roller"
          label="ad"
          :reduce="rol => rol.id"
          placeholder="Rol Seçin"
        />
        <span v-if="formHatalar.rol" class="error">{{ formHatalar.rol }}</span>
        </div>
      </div>

    
    
    
    <div class="col-12 mb-1 mt-2" :class="{ 'text-danger': formHatalar.profil }"> 
       
        <picture-input 
          ref="profil"
          width="600" 
          height="600" 
          margin="16" 
          accept="image/jpeg,image/png" 
          size="10" 
          button-class="btn"
          :custom-strings="{
            upload: '<h1>Profil</h1>',
            drag: 'Tıklayın veya sürükleyip bırakın'
          }"
          @change="profilDegistir">
        </picture-input>
      </div>	
        <span v-if="formHatalar.profil" class="error">{{ formHatalar.profil }}</span>
   
    
    
    

     
    </div>

    


 

    <div class="d-flex justify-content-around  mt-4"> 
      
      <button type="button" class="btn btn-light  mr-2" @click="iptalEt"><em class="icon ni ni-cross"></em><span>İptal Et</span></button>
      <button type="submit" class="btn btn-primary"><em class="icon ni ni-check"></em><span>Kaydet</span></button>
    </div>
  </form>

</template>

<script>
import axiosCustom from "@/services/axiosCustom";

import vSelect from "vue-select";




import PictureInput from 'vue-picture-input'





export default {
components: {
  
      vSelect,
  
  
  
    PictureInput,
  
  
  
  
},
props: {
  formIslem: String,
  formData: Object,
  formKaydetSonrasi: Function,
  formIptal: Function,

},
data() {
  return {
    
    profilSecili: null,
    
    
  roller: [],
  
  

  
    localFormData: { ...this.formData }, 
    formHatalar:{},

    

  };
},
created() {
  
  this.rollerGetir();
  
   

  
},
watch: {
      formData: {
        handler(newFormData) {
          this.localFormData = { ...newFormData };

  
          
          
          
         
          
        },
        immediate: true, // Component oluşturulduğunda da tetikle
      },
    },
methods: {
  
  async rollerGetir() {
    try {
      const response = await axiosCustom.get("roller"); 
      this.roller = response.data;
    } catch (error) {
      console.error("roller alma hatası: ", error);
    }
  },
  
  



  formDogrula() {
    this.formHatalar = {};
    var kontrol=true;
    
    
    if (!this.localFormData.ad) {
      this.formHatalar.ad = "Ad boş bırakılamaz.";
      kontrol=false;
    }
    
    
    
    if (!this.localFormData.soyad) {
      this.formHatalar.soyad = "Soyad boş bırakılamaz.";
      kontrol=false;
    }
    
    
       
    if (this.localFormData.sifre!=this.localFormData.sifre2) {
      this.formHatalar.sifre = "Şifreler Eşleşmiyor";
      this.formHatalar.sifre2 = "Şifreler Eşleşmiyor";
      kontrol=false;
    }
    
    if (!this.localFormData.kullaniciadi) {
      this.formHatalar.kullaniciadi = "Kullanıcı Adı boş bırakılamaz.";
      kontrol=false;
    }
    
    
     
    
  
  
  
  
  if (!this.localFormData.rol) {
      this.formHatalar.rol = "Rol boş bırakılamaz.";
      kontrol=false;
    }
    
  
   
 


    return kontrol;
  },
  async  gonder() {
    if(this.formDogrula()){
  // FormData oluştur
  const newFormData = new FormData();
  newFormData.append("ad", this.localFormData.ad ?? '');
  newFormData.append("soyad", this.localFormData.soyad ?? '');
  newFormData.append("kullaniciadi", this.localFormData.kullaniciadi ?? '');
  newFormData.append("telefon", this.localFormData.telefon ?? '');
  
  
  newFormData.append("rol", this.localFormData.rol ?? '');
  newFormData.append("sifre", this.localFormData.sifre ?? '');
  newFormData.append("sifre2", this.localFormData.sifre2 ?? '');
   
  newFormData.append("profil",  this.profilSecili);
  

  try {
  if (this.formIslem === "duzenle") {
    axiosCustom
      .post("kullanicilar/duzenle/" + this.localFormData.id, newFormData)
      .then(() => {
        

        this.$toast.success("Kullanıcı Düzenlendi");
        this.formKaydetSonrasi();
      })
      .catch((error) => {
        console.error("Güncelleme hatası: ", error);
        this.$toast.error("Güncelleme hatası");
      });
  } else {
    axiosCustom
      .post("kullanicilar/ekle", newFormData)
      .then(() => {
        

        this.$toast.success("Yeni Kullanıcı Eklendi");
        this.formKaydetSonrasi();
      })
      .catch((error) => {
        console.error("Ekleme hatası: ", error);
        this.$toast.error("Ekleme hatası");
      });
  }
} catch (error) {
    console.error('Kaydetme hatası: ', error);
    this.$toast.error('Kaydetme hatası');
  }
} 
  },
  
  iptalEt() {
    this.formIptal();
  },

  

  
  profilDegistir(event) {
        // Dosya seçildiğinde bu metod çağrılır
        this.profilSecili = event.target.files[0];

        // Resmin önizlemesini gösterme
        if (this.profilSecili) {
            const reader = new FileReader();

            reader.onload = (e) => {
                this.profilOnizleme = e.target.result;
            };

            reader.readAsDataURL(this.profilSecili);
        }
    },
    
},
};
</script>